import { devError } from '../../utils/log';

const STORAGE_KEY = 'stampCardSeenProgress';

const MAX_TRACKED_CARDS = 20;

type SeenProgress = Record<string, number>;

function readAll(): SeenProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    return raw ? (JSON.parse(raw) as SeenProgress) : {};
  } catch (error) {
    devError('Error reading seen stamp progress', error);

    return {};
  }
}

export function readSeenStampCount(userStampCardId: string): number {
  return readAll()[userStampCardId] ?? 0;
}

export function hasSeenStampCard(userStampCardId: string): boolean {
  return userStampCardId in readAll();
}

export function writeSeenStampCount(userStampCardId: string, stampsCompleted: number): void {
  try {
    const all = readAll();

    // An absent card still has to be written, even at zero stamps: that write is what records the
    // player has now been shown the card at all, and without it a card with nothing earned yet
    // would re-open its pop-up on every login.
    if (userStampCardId in all && all[userStampCardId] >= stampsCompleted) return;

    all[userStampCardId] = stampsCompleted;

    const trimmed = Object.entries(all).slice(-MAX_TRACKED_CARDS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(trimmed)));
  } catch (error) {
    devError('Error saving seen stamp progress', error);
  }
}
